import { Color } from "@tiptap/extension-text-style"
import type { Slice } from "@tiptap/pm/model"
import { Plugin } from "@tiptap/pm/state"
import { clampColor } from "../../util/clamp-color"

/** The allowed text colors. Reused as the underline colors by the underline picker. */
export const TEXT_COLORS: { name: string; color: string }[] = [
  { name: "Red", color: "rgb(216, 90, 98)" },
  { name: "Orange", color: "rgb(216, 113, 49)" },
  { name: "Yellow", color: "rgb(207, 163, 42)" },
  { name: "Green", color: "rgb(133, 164, 55)" },
  { name: "Teal", color: "rgb(104, 166, 135)" },
  { name: "Blue", color: "rgb(23, 151, 186)" },
  { name: "Navy", color: "rgb(95, 138, 180)" },
  { name: "Purple", color: "rgb(120, 111, 159)" },
  { name: "Magenta", color: "rgb(164, 70, 128)" },
]

// Cp mod: Clamp text colors to our allowed list when pasting.
export const CpColor = Color.extend({
  addProseMirrorPlugins() {
    return [...(this.parent?.() ?? []), new Plugin({ props: { transformPasted } })]
  },
})

function transformPasted(slice: Slice): Slice {
  slice.content.descendants((node) => {
    for (const mark of node.marks) {
      if (mark.type.name === "textStyle" && mark.attrs["color"]) {
        const clamped = clampColor(
          TEXT_COLORS.map((entry) => entry.color),
          mark.attrs["color"] as string,
        )
        // Mutating mark attrs directly for paste-transform convenience; marks
        // are nominally immutable but this is safe inside transformPasted.
        // @ts-expect-error mark.attrs has no index signature
        mark.attrs = { ...mark.attrs, color: clamped }
      }
    }
  })
  return slice
}
